import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import Text from '../Text';
import { HEADING_COLORS } from '../Text/Base/Base';
import { media, mixins, colors } from '../../css';

export const StyledOpenButtonWrapper = styled.button`
  cursor: pointer;
  z-index: 1;
  position: relative;
  margin-bottom: ${props => (!props.noMargins ? mixins.pxToRem(16) : 0)};
  padding: 0;
  text-align: left;
  transition: opacity 100ms ease-in;
  ${props => props.fullWidth && `display: flex; justify-content: space-between; width: 100%;`};
  ${props => props.disabled && `pointer-events: none; opacity: 0.5;`};
  ${props => !props.pointer && `pointer-events: none;`};
  ${media.greaterThan('lg')`
    margin-bottom: 0;
  `};

  ${props =>
    props.hasBorder
      ? `border-top: 1px solid ${colors.colorGrey04}; padding-top: ${mixins.pxToRem(16)}; width:100%; text-align: left;`
      : null};
`;

export const StyledButtonText = styled(Text.CopyBody)`
  display: inline-block;
  padding: ${props =>
    props.iconPlacement === 'before' ? `0 0 0 ${mixins.pxToRem(10)}` : `0 ${mixins.pxToRem(10)} 0 0`};
  vertical-align: middle;
  margin: 0;
`;

export const StyledSVGIcon = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const spreadSpinner = ({ spinnerColor, ...rest }) => <CircularProgress {...rest} />;
export const StyledSpinner = styled(spreadSpinner)`
  && {
    margin: 0px;
    color: ${props => HEADING_COLORS[props.spinnerColor] || colors.colorBlue};
  }
`;
